import { listRecognitionRecipients } from '@kudos/http-client'
import FieldLabel from '@shared/forms/FieldLabel'
import TenantMembersAndTeamsSearchField from '@shared/forms/tenantMemberAndTeamSearchField/TenantMemberAndTeamSearchField'
import { RecognitionFormData } from '@tenant/recognition/RecognitionModal/sendRecognitionView/useSendRecognitionForm'
import { T } from '@transifex/react'
import { useFormContext } from 'react-hook-form'

const MobileRecognitionRecipientsView = () => {
  const { control } = useFormContext<RecognitionFormData>()

  return (
    <TenantMembersAndTeamsSearchField
      control={control}
      name="sendTo"
      searchFn={listRecognitionRecipients}
      label={
        <FieldLabel labelStyle={{ mt: 0 }}>
          <T _str="To" />
        </FieldLabel>
      }
      showAvatars
      zIndexPlacement="modal"
    />
  )
}

export default MobileRecognitionRecipientsView
